module.exports = __webpack_public_path__ + "static/media/stamp.e8a05f14.png";